<script>
  import { onMount, onDestroy } from "svelte";

  export let address;
  $: if (address) {
    window.requestAnimationFrame(function() {
      render();
    });
  }
  let width = window.innerWidth;
  let height = 300;
  let pixelRatio = window.devicePixelRatio;

  let canvas;
  let context;
  let fontSize = 16 * pixelRatio;
  let lineHeight = 20 * pixelRatio;
  let imageSize = 100 * pixelRatio;
  let fontFamily =
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica';
  let img;

  onMount(() => {
    context = canvas.getContext("2d");
    window.requestAnimationFrame(function() {
      render();
    });
  });

  function render() {
    context.clearRect(0, 0, canvas.width, canvas.height);

    context.save();
    context.strokeStyle = "rgb(4, 0, 114)";
    context.lineWidth = 2;
    context.rect(0, 0, canvas.width, canvas.height);

    context.shadowColor = "rgba(4, 0, 114, 0.7)";
    context.shadowBlur = 6;
    context.shadowOffsetX = 6;
    context.shadowOffsetY = 6;
    context.strokeRect(40, 20, canvas.width - 80, canvas.height - 40);

    context.fillStyle = "white";
    context.fillRect(40, 20, canvas.width - 80, canvas.height - 40);
    context.shadowColor = "";
    context.restore();

    context.save();
    context.fillStyle = "rgb(4, 0, 114)";
    context.textAlign = "left";
    context.textBaseline = "bottom";
    context.font = `${fontSize}px ${fontFamily}`;
    let lines = address.split("\n");
    let x = canvas.width / 2 - 40 * pixelRatio;
    let y = canvas.height - lines.length * lineHeight - 40;
    let maxTextLength = 0;
    for (let i = 0; i < lines.length; i++) {
      let text = lines[i];
      maxTextLength = Math.max(maxTextLength, context.measureText(text).width);
    }

    let maxWidth =
      canvas.width > maxTextLength + 120 ? maxTextLength : canvas.width - 120;
    let textX = Math.max(60, canvas.width - maxTextLength - 60);
    for (let i = 0; i < lines.length; i++) {
      let text = lines[i];
      context.fillText(text, textX, y + i * lineHeight, maxWidth);
    }
    context.restore();

    let renderImage = function() {
      context.drawImage(
        img,
        canvas.width - imageSize - 50,
        20,
        imageSize,
        imageSize
      );
    };
    if (!img) {
      img = new Image();
      img.onload = renderImage;
      img.src = "/thaipost.svg";
    } else {
      renderImage();
    }
  }

  function handleResize() {
    width = window.innerWidth;
    height = 300;
    pixelRatio = window.devicePixelRatio;
    window.requestAnimationFrame(function() {
      render();
    });
  }
</script>

<canvas
  bind:this={canvas}
  width={width * pixelRatio}
  height={height * pixelRatio}
  style="width: {width}px; height: {height}px;" />

<svelte:window on:resize|passive={handleResize} />
